import React from 'react';
import PropTypes from 'prop-types';
import StyledSVGIcon from './SVGIcon.style';

/* DOCUMENTATION
 *
 * * The color of the icon can be defined by the parent tag color css property. This color will be used as the fill for the icon.
 *
 */

/**
 * Render one of the svg icon's from `app/assets/svg-icon-sprite.svg`.
 *
 */

export default class SVGIcon extends React.PureComponent {
  render() {
    const { icon, color, size, className } = this.props;
    return (
      <StyledSVGIcon
        $color={color}
        $size={size}
        focusable={false}
        viewBox="0 0 24 24"
        aria-hidden="true"
        role="presentation"
        className={className}
      >
        <use
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref={`#svg-icon-sprite_icon-${icon}`}
        />
      </StyledSVGIcon>
    );
  }
}

SVGIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['current']),
  size: PropTypes.oneOf(['small', 'medium', 'large', 'inherit']),
  /** ClassName is supported such that styled components can pass extra styling.
   * Do not use this to adjust the styling, because the ordering of the applied tailwind classes is undeterministic */
  className: PropTypes.string
};

SVGIcon.defaultProps = {
  color: 'current',
  size: 'large',
  className: ''
};
